import { EntityConnectionTypeDetailsFragment } from 'generated/graphql';

/**
 * Returns the EntityType (entityType1 or entityType2)
 * on an EntityConnectionType where the entityTypeId is not
 * the same as the currEntityTypeId param.
 * In a case where both sides of the connection are to the same type,
 * and match the currentEntityType, it will return the entityType of
 * the id passed.
 *
 * @example ```
 *    currEntityTypeId = "1"
 *   { entityType1: { id: "2"} }, { entityType1: { id: "1"} }
 *
 *   returns entityType1
 *
 *   currEntityTypeId = "2"
 *   { entityType1: { id: "2"} }, { entityType1: { id: "2"} }
 *
 *   also returns entityType1
 * ```
 */
export function getOppositeEntityTypeFromConnection(
  currEntityTypeId: string,
  entityConnectionType: EntityConnectionTypeDetailsFragment
) {
  if (entityConnectionType?.entityType1?.id !== currEntityTypeId) {
    return entityConnectionType?.entityType1;
  }
  return entityConnectionType?.entityType2;
}
